// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1dJYv","buttons":"SendReceipts_buttons__3Vt1D","email":"SendReceipts_email__gVKhU","bookApptTitle":"SendReceipts_bookApptTitle__dEFh4"};